module.exports = __webpack_public_path__ + "img/blight_stone.a89ccf12.png";